import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import './multiprise.scss';

const CODE = `#include <PZEM004Tv30.h>
#include <WiFi.h>
#include <WebServer.h>
#include <Preferences.h>
#include <time.h>

#define RELAY_PIN 26
#define RELAY_ON HIGH
#define RELAY_OFF LOW

const char* ssid = "••••••••";
const char* password = "••••••••";

IPAddress local_IP(192, 168, 1, 250);
IPAddress gateway(192, 168, 1, 1);
IPAddress subnet(255, 255, 255, 0);
IPAddress primaryDNS(8, 8, 8, 8);
IPAddress secondaryDNS(8, 8, 4, 4);

PZEM004Tv30 pzem(Serial2, 16, 17);
WebServer server(80);
Preferences prefs;

bool relayState = false;

float voltage = 0;
float current = 0;
float power = 0;
float energy = 0;

unsigned long lastPzemRead = 0;
const unsigned long pzemInterval = 4000;

// Planning
bool scheduleEnabled = false;
int scheduleMode = 0; // 0 = quotidien, 1 = hebdomadaire
int onHour = 8;
int onMinute = 0;
int offHour = 22;
int offMinute = 0;
byte daysMask = 0b01111110; // lun->ven par défaut

int lastOnDay = -1;
int lastOnMinute = -1;
int lastOffDay = -1;
int lastOffMinute = -1;

void readPzem() {
  float v = pzem.voltage();
  float c = pzem.current();
  float p = pzem.power();
  float e = pzem.energy();

  if (!isnan(v)) voltage = v;
  if (!isnan(c)) current = c;
  if (!isnan(p)) power = p;
  if (!isnan(e)) energy = e;
}

void relayOn() {
  digitalWrite(RELAY_PIN, RELAY_ON);
  relayState = true;
}

void relayOff() {
  digitalWrite(RELAY_PIN, RELAY_OFF);
  relayState = false;
}

void loadSchedule() {
  prefs.begin("planning", false);
  scheduleEnabled = prefs.getBool("enabled", false);
  scheduleMode = prefs.getInt("mode", 0);
  onHour = prefs.getInt("onHour", 8);
  onMinute = prefs.getInt("onMinute", 0);
  offHour = prefs.getInt("offHour", 22);
  offMinute = prefs.getInt("offMinute", 0);
  daysMask = prefs.getUChar("days", 0b01111110);
}

void saveSchedule() {
  prefs.putBool("enabled", scheduleEnabled);
  prefs.putInt("mode", scheduleMode);
  prefs.putInt("onHour", onHour);
  prefs.putInt("onMinute", onMinute);
  prefs.putInt("offHour", offHour);
  prefs.putInt("offMinute", offMinute);
  prefs.putUChar("days", daysMask);
}

String checked(bool condition) {
  return condition ? "checked" : "";
}

String selected(bool condition) {
  return condition ? "selected" : "";
}

bool isTodayAllowed(int wday) {
  if (scheduleMode == 0) return true;
  return bitRead(daysMask, wday);
}

void checkSchedule() {
  if (!scheduleEnabled) return;

  struct tm timeinfo;
  if (!getLocalTime(&timeinfo)) return;

  int currentHour = timeinfo.tm_hour;
  int currentMinute = timeinfo.tm_min;
  int currentDay = timeinfo.tm_yday;
  int wday = timeinfo.tm_wday;

  if (!isTodayAllowed(wday)) return;

  if (currentHour == onHour && currentMinute == onMinute) {
    if (lastOnDay != currentDay || lastOnMinute != currentMinute) {
      relayOn();
      lastOnDay = currentDay;
      lastOnMinute = currentMinute;
    }
  }

  if (currentHour == offHour && currentMinute == offMinute) {
    if (lastOffDay != currentDay || lastOffMinute != currentMinute) {
      relayOff();
      lastOffDay = currentDay;
      lastOffMinute = currentMinute;
    }
  }
}

String getTimeText() {
  struct tm timeinfo;
  if (!getLocalTime(&timeinfo)) return "Heure non synchronisee";
  char buffer[30];
  strftime(buffer, sizeof(buffer), "%d/%m/%Y %H:%M:%S", &timeinfo);
  return String(buffer);
}

void handleRoot() {
  String html = "";
  html += "<!DOCTYPE html><html><head>";
  html += "<meta charset='UTF-8'>";
  html += "<meta name='viewport' content='width=device-width, initial-scale=1.0'>";
  html += "<meta http-equiv='refresh' content='4'>";
  html += "<title>Multiprise Connectee</title>";
  html += "</head><body>";
  // ... interface web embarquée
  server.send(200, "text/html", html);
}

void handleOn()  { relayOn();  server.sendHeader("Location", "/"); server.send(303); }
void handleOff() { relayOff(); server.sendHeader("Location", "/"); server.send(303); }

void handleSave() {
  scheduleEnabled = server.hasArg("enabled");
  scheduleMode = server.arg("mode").toInt();
  String onT = server.arg("onTime");
  String offT = server.arg("offTime");
  if (onT.length() == 5) { onHour = onT.substring(0,2).toInt(); onMinute = onT.substring(3,5).toInt(); }
  if (offT.length() == 5) { offHour = offT.substring(0,2).toInt(); offMinute = offT.substring(3,5).toInt(); }
  daysMask = 0;
  for (int i = 0; i < 7; i++) { if (server.hasArg("d" + String(i))) bitSet(daysMask, i); }
  saveSchedule();
  server.sendHeader("Location", "/");
  server.send(303);
}

void setup() {
  Serial.begin(115200);
  pinMode(RELAY_PIN, OUTPUT);
  relayOff();
  loadSchedule();

  WiFi.mode(WIFI_STA);
  WiFi.config(local_IP, gateway, subnet, primaryDNS, secondaryDNS);
  WiFi.begin(ssid, password);
  while (WiFi.status() != WL_CONNECTED) { delay(500); }

  configTzTime("CET-1CEST,M3.5.0/2,M10.5.0/3", "pool.ntp.org", "time.nist.gov");

  server.on("/", handleRoot);
  server.on("/on", handleOn);
  server.on("/off", handleOff);
  server.on("/save", handleSave);
  server.begin();

  readPzem();
  lastPzemRead = millis();
}

void loop() {
  server.handleClient();
  checkSchedule();

  if (millis() - lastPzemRead >= pzemInterval) {
    lastPzemRead = millis();
    readPzem();
  }
}`;

const BASE = '/img/projets/multiprise/';

const phases = {
  1: [
    { src: 'presentation.jpg', alt: 'Présentation du projet' },
    { src: 'esp32.jpg',        alt: 'ESP32' },
    { src: 'relai.jpg',        alt: 'Relai 5V / 230V' },
    { src: 'porte-fusible.jpg',alt: 'Porte-fusible' },
  ],
  2: [
    { src: 'cable.jpg',        alt: 'Câblage' },
    { src: 'boitier-final.jpg',alt: 'Câblage interne' },
    { src: 'porte-fusible.jpg',alt: 'Porte-fusible' },
  ],
  3: [
    { src: 'celleci.jpg',      alt: 'Interface web' },
    { src: 'accessibilite.jpg',alt: 'Interface accessibilité' },
    { src: 'planning.jpg',     alt: 'Planning du projet' },
  ],
};

function Multiprise() {
  const navigate = useNavigate();
  const [modal, setModal] = useState(null); // { phase, index }
  const [codeOpen, setCodeOpen] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const openModal  = (phase, index) => setModal({ phase, index });
  const closeModal = () => setModal(null);

  const prev = useCallback(() => {
    setModal(m => ({
      ...m,
      index: (m.index - 1 + phases[m.phase].length) % phases[m.phase].length
    }));
  }, []);

  const next = useCallback(() => {
    setModal(m => ({
      ...m,
      index: (m.index + 1) % phases[m.phase].length
    }));
  }, []);

  useEffect(() => {
    if (!modal) return;
    const onKey = (e) => {
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft')  prev();
      if (e.key === 'Escape')     closeModal();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [modal, next, prev]);

  const currentImg = modal ? phases[modal.phase][modal.index] : null;

  const Img = ({ phase, index }) => {
    const img = phases[phase][index];
    return (
      <img
        src={BASE + img.src}
        alt={img.alt}
        onClick={() => openModal(phase, index)}
      />
    );
  };

  return (
    <div className="multiprise-page">

      {/* MODAL */}
      {modal && (
        <div className="mp-modal" onClick={closeModal}>
          <button className="mp-modal-close" onClick={closeModal} aria-label="Fermer">✕</button>

          <button className="mp-modal-nav mp-modal-prev" onClick={e => { e.stopPropagation(); prev(); }} aria-label="Précédent">
            ‹
          </button>

          <img
            src={BASE + currentImg.src}
            alt={currentImg.alt}
            onClick={e => e.stopPropagation()}
          />

          <button className="mp-modal-nav mp-modal-next" onClick={e => { e.stopPropagation(); next(); }} aria-label="Suivant">
            ›
          </button>

          <div className="mp-modal-counter">
            {modal.index + 1} / {phases[modal.phase].length}
          </div>
        </div>
      )}

      {/* CODE MODAL */}
      {codeOpen && (
        <div className="mp-modal mp-code-modal" onClick={() => setCodeOpen(false)}>
          <button className="mp-modal-close" onClick={() => setCodeOpen(false)} aria-label="Fermer">✕</button>
          <div className="mp-code-container" onClick={e => e.stopPropagation()}>
            <div className="mp-code-header">
              <span className="mp-code-title">multiprise.ino</span>
              <div className="mp-code-dots"><span/><span/><span/></div>
            </div>
            <SyntaxHighlighter
              language="cpp"
              style={vscDarkPlus}
              showLineNumbers
              customStyle={{ margin: 0, borderRadius: '0 0 12px 12px', fontSize: '12px', maxHeight: '75vh', overflowY: 'auto' }}
            >
              {CODE}
            </SyntaxHighlighter>
          </div>
        </div>
      )}

      {/* TOP BAR */}
      <header className="mp-topbar">
        <div className="mp-topbar-inner">
          <div className="mp-topbar-left">
            <span className="material-symbols-outlined filled mp-icon-filled">bolt</span>
            <span className="mp-topbar-title">Mes Projets</span>
          </div>
          <button className="mp-back-btn" onClick={() => navigate(-1)}>
            <span className="material-symbols-outlined" style={{fontSize:'20px'}}>arrow_back</span>
            Retour
          </button>
        </div>
      </header>

      <main className="mp-main">

        {/* HERO */}
        <div className="mp-hero">
          <div className="mp-badge">PROJET IOT</div>
          <h1 className="mp-title">Construction d'une multiprise connectée</h1>
          <p className="mp-intro">
            J'ai amélioré une multiprise en la rendant intelligente et connectée, de façon à pouvoir <strong style={{color:'#c9d8ff'}}>l'allumer et l'éteindre à distance, mesurer sa consommation en temps réel et de manière automatisée</strong> — le tout en garantissant la <strong style={{color:'#c9d8ff'}}>sécurité électrique</strong> des utilisateurs et des équipements connectés.
          </p>
        </div>

        <div className="mp-divider" />

        {/* PHASE 1 */}
        <div className="mp-phase">
          <div className="mp-phase-header">
            <span className="mp-phase-num">1</span>
            <h2>Conception Technique</h2>
          </div>

          <div className="mp-img-main">
            <Img phase={1} index={0} />
          </div>

          <div className="mp-img-grid mp-img-grid-3">
            <div className="mp-img-cell"><Img phase={1} index={1} /></div>
            <div className="mp-img-cell"><Img phase={1} index={2} /></div>
            <div className="mp-img-cell"><Img phase={1} index={3} /></div>
          </div>

          <div className="mp-thread">
            <div className="mp-comp-list">
              <div className="mp-comp-item"><span className="mp-comp-name">ESP32</span><span className="mp-comp-role">Microcontrôleur</span></div>
              <div className="mp-comp-item"><span className="mp-comp-name">PZEM-004T</span><span className="mp-comp-role">Mesure courant et tension</span></div>
              <div className="mp-comp-item"><span className="mp-comp-name">Pince CT</span><span className="mp-comp-role">Capteur de courant non-invasif</span></div>
              <div className="mp-comp-item"><span className="mp-comp-name">Relais</span><span className="mp-comp-role">Commute le circuit 230V</span></div>
              <div className="mp-comp-item"><span className="mp-comp-name">HLK-PM01</span><span className="mp-comp-role">Convertit 230V → 5V</span></div>
              <div className="mp-comp-item"><span className="mp-comp-name">Fusible & Porte-fusible</span><span className="mp-comp-role">Protège contre surintensités</span></div>
              <div className="mp-comp-item"><span className="mp-comp-name">Arduino IDE</span><span className="mp-comp-role">Programmation de l'ESP32</span></div>
            </div>
            <div className="mp-stat-grid">
              <div className="mp-stat-card">
                <span className="material-symbols-outlined mp-stat-icon">wifi</span>
                <span className="mp-stat-label">Connecté via Wi-Fi</span>
              </div>
            </div>
            <div className="mp-callout">
              <div className="mp-callout-label">PROTECTION</div>
              <p>Intégration d'un <strong>porte-fusible</strong> pour une protection accrue contre les surintensités. Ce dispositif garantit l'intégrité des composants électroniques et la sécurité de l'utilisateur final en cas de défaut sur la ligne.</p>
            </div>
          </div>
        </div>

        <div className="mp-divider" />

        {/* PHASE 2 */}
        <div className="mp-phase">
          <div className="mp-phase-header">
            <span className="mp-phase-num">2</span>
            <h2>Réalisation</h2>
          </div>

          <div className="mp-img-main mp-img-sm">
            <Img phase={2} index={0} />
          </div>
          <div className="mp-img-grid mp-img-grid-sm">
            <div className="mp-img-cell"><Img phase={2} index={1} /></div>
            <div className="mp-img-cell"><Img phase={2} index={2} /></div>
          </div>

          <div className="mp-thread">
            <p className="mp-body">
              Le projet relie une multiprise alimentée en <strong>basse tension 230V AC</strong> à un microcontrôleur ESP32 fonctionnant en <strong>très basse tension de sécurité (TBTS) à 5V</strong>, via un convertisseur HLK-PM01. La commutation du circuit 230V est assurée par un relais piloté depuis l'ESP32, qui communique en <strong>Wi-Fi 2.4GHz</strong> pour permettre le contrôle et la supervision à distance.
            </p>
<p className="mp-body">
              Via une interface web embarquée accessible depuis un téléphone, il est possible d'<strong>allumer et éteindre la multiprise à distance</strong> en temps réel. L'interface affiche également les données de consommation en direct — <strong>tension, intensité, puissance et énergie</strong> consommée — et un planning d'automatisation permet de programmer l'allumage et l'extinction sans intervention manuelle.
            </p>
          </div>
        </div>

        <div className="mp-divider" />

        {/* PHASE 3 */}
        <div className="mp-phase">
          <div className="mp-phase-header">
            <span className="mp-phase-num">3</span>
            <h2>Produit en action</h2>
          </div>

          <div className="mp-img-main mp-img-sm">
            <Img phase={3} index={0} />
          </div>
          <div className="mp-img-grid mp-img-grid-sm">
            <div className="mp-img-cell"><Img phase={3} index={1} /></div>
            <div className="mp-img-cell"><Img phase={3} index={2} /></div>
          </div>

          <div className="mp-thread">
            <div className="mp-callout">
              <div className="mp-callout-label">AUTOMATISATION</div>
              <p>Un <strong>planning hebdomadaire ou quotidien</strong> a été mis en place pour automatiser l'allumage et l'extinction de la multiprise selon des horaires programmés — sans intervention manuelle. Le tout est pleinement fonctionnel.</p>
            </div>
            <button className="mp-code-btn" onClick={() => setCodeOpen(true)}>
              <span className="mp-code-btn-icon">{'</>'}</span>
              Voir le code source
            </button>
          </div>
        </div>

        <div className="mp-divider" />

        {/* CTA */}
        <div className="mp-cta">
          <h3>Intéressé par mes projets ?</h3>
          <a href="mailto:philippe_genot@hotmail.fr?subject=J'ai vu ton projet Multiprise Connectée" className="mp-cta-btn">
            Me contacter
            <span className="material-symbols-outlined">arrow_forward</span>
          </a>
        </div>

      </main>

    </div>
  );
}

export default Multiprise;
